export default __webpack_public_path__ + "static/media/alignment-vertical-center.35334abc.svg";